import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_17 = { class: "col p-0" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_24 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_25 = { class: "col p-0" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_28 = { class: "col p-0" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_31 = { class: "col p-0" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_34 = { class: "col p-0" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = ["disabled", "placeholder"]
const _hoisted_37 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_38 = { class: "col p-0" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = ["disabled", "placeholder"]
const _hoisted_41 = { class: "form-group mb-2 col" }
const _hoisted_42 = { class: "col-auto p-0 text-end" }
const _hoisted_43 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_44 = { class: "col-sm-12" }
const _hoisted_45 = { class: "card card-body mb-0" }
const _hoisted_46 = { class: "overflow-auto" }
const _hoisted_47 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_48 = { class: "bg-light" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_MerchantMultiselect, {
                          multiple: true,
                          modelValue: _ctx.merchantsFilter,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_StoreMultiselect, {
                          multiple: true,
                          modelValue: _ctx.storesFilter,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_TrafficGroupMultiselect, {
                          multiple: true,
                          small: "",
                          modelValue: _ctx.trafficGroupsFilter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_19)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_23)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Multiselect, {
                          id: "options",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.options,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.payment_options')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Multiselect, {
                          id: "types",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.types,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                          options: Object.values(_ctx.Direction),
                          "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.type')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Multiselect, {
                          id: "currency",
                          class: "multiselect-sm multiselect-capitalize",
                          modelValue: _ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                          options: _ctx.store.getters['currencyMethods/currencies'],
                          "custom-label": (opt) => opt,
                          multiple: false,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.currency')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          disabled: !_ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.amountFrom) = $event)),
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.from_sum')
                        }, null, 8, _hoisted_36), [
                          [_vModelText, _ctx.requestDTO.amountFrom]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          disabled: !_ctx.requestDTO.currency,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.amountTo) = $event)),
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.to_sum')
                        }, null, 8, _hoisted_40), [
                          [_vModelText, _ctx.requestDTO.amountTo]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_48, [
                    _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('labels.amount')), 1),
                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('deal_status.total')), 1),
                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('deal_status.processed')), 1),
                    _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.helper.trans('deal_status.rejected')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.amount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.invoicesCount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dealsCount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.invoicesCount - item.dealsCount)), 1)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}